module.exports = __webpack_public_path__ + "static/img/jm.a5de6786.svg";